// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  AUTH_BASE_URL: 'https://pantaloons-api-dev.sttarter.com/api/v1/',
  BASE_URL_IMAGE :'https://pantaloons-api-dev.sttarter.com',
  url:'https://d2q2o0tvjtplq7.cloudfront.net/sample-template.csv',
  staffUrl: 'https://d2q2o0tvjtplq7.cloudfront.net/Sample-staff-template - 1.csv'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
